(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let sectionObserver;

  function prepareSections() {
    const sections = [...document.querySelectorAll('#MainContent > .shopify-section')];
    if (!sections.length) return;

    sectionObserver?.disconnect();
    sections.forEach((section) => {
      section.classList.remove('home-motion-section', 'home-motion-visible');
    });

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      sections.forEach((section) => section.classList.add('home-motion-visible'));
      return;
    }

    sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('home-motion-visible');
        sectionObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });

    sections.slice(1).forEach((section) => {
      section.classList.add('home-motion-section');
      sectionObserver.observe(section);
    });
  }

  function initializeHomepage() {
    document.body.classList.add('template-index-motion');
    prepareSections();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeHomepage, { once: true });
  } else {
    initializeHomepage();
  }

  document.addEventListener('shopify:section:load', prepareSections);
})();
